import api from './axiosInstance';
import { API_BASE_URL } from '../config';

const LOGIN_LOG_URL = `${API_BASE_URL}/LogLogin`;

export const getPagedLoginLogs = async (
  page = 1,
  pageSize = 10,
  sortBy = null,
  desc = null
) => {
  try {
    const params = { page, pageSize };
    if (sortBy) {
      params.sortBy = sortBy;
    }
    if (desc !== null && desc !== undefined) {
      params.desc = desc;
    }
    const response = await api.get(LOGIN_LOG_URL, { params });
    return {
      total: response.data.total || 0,
      data: response.data.data || [],
    };
  } catch (error) {
    console.error('Error fetching login logs:', error);
    throw error;
  }
};

export const filterLoginLogsByDateRange = async (
  startDate,
  endDate,
  page = 1,
  pageSize = 10,
  sortBy = null,
  desc = null
) => {
  try {
    const params = {
      startDate,
      endDate,
      page,
      pageSize,
    };
    if (sortBy) {
      params.sortBy = sortBy;
    }
    if (desc !== null && desc !== undefined) {
      params.desc = desc;
    }
    const response = await api.get(`${LOGIN_LOG_URL}/filter`, { params });
    return {
      total: response.data.total || 0,
      data: response.data.data || [],
    };
  } catch (error) {
    console.error('Error filtering login logs:', error);
    throw error;
  }
};
